import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Update,
  GetById,
} from "adminApi/CurrencySettingsApi/CurrencySettings";
import fields from "../json/CurrencyFeilds.json";
import { validateForm } from "utils/validation";
import { PaymentCurrencyRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditPaymentCurrencyForm from "./Componates/EditPaymentCurrencyForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditPaymentCurrency = () => {
  const navigate = useNavigate();      
  const { id } = useParams();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues } = useFormChange(initialValues, PaymentCurrencyRules);

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({id,data:formData});
    },
    (vals) => validateForm(vals, PaymentCurrencyRules),
    () =>{ 
      return navigate(-1)
    },
    "Currency updated successfully"
  );
  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditPaymentCurrencyForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update"
      />
    </>
  );
};

export default EditPaymentCurrency;
